import cloneDeep from "lodash.clonedeep";

export type RounderObject = {
  order: number;
  percentage: number;
  name?: string;
  width?: number;
};

export type GroupRounderObject = {
  percentage: number;
};

export const groupRounder = <T extends GroupRounderObject>(
  objects: T[]
): T[] => {
  const clonedObjects = cloneDeep(objects);

  let carry = 0;
  let total = 0;

  for (let i = 0; i < clonedObjects.length; i++) {
    const group = clonedObjects[i];
    let percentage = group.percentage;

    percentage += carry;
    const roundedPercentage = Math.round(percentage);
    carry = percentage - roundedPercentage;
    group.percentage = roundedPercentage;

    total += roundedPercentage;
  }

  for (let i = clonedObjects.length - 1; i >= 0; i--) {
    const group = clonedObjects[i];
    const remainder = total - 100;
    if (remainder === 0) {
      break;
    }
    if (group.percentage === 0) {
      continue;
    }

    const toSubtract = Math.min(group.percentage, remainder);

    group.percentage -= toSubtract;
    total -= toSubtract;
  }

  return clonedObjects;
};
